<template>
  <el-popover v-model="visible" placement="top" width="250">
    <el-form ref="form" label-width="80px" :model="form" :rules="rules">
      <el-form-item label="方式" prop="compensationType">
        <el-radio-group v-model="form.compensationType">
          <el-radio :label="1">补</el-radio>
          <el-radio :label="2">扣</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="金额" prop="compensationNum">
        <el-input v-model="form.compensationNum" :placeholder="`0~${maxNum}`" />
      </el-form-item>
    </el-form>
    <div style="text-align: right; margin: 0">
      <el-button size="mini" type="text" @click="onCancel">取消</el-button>
      <el-button type="primary" size="mini" @click="onSure">确定</el-button>
    </div>
    <el-button slot="reference" type="text"><span v-if="row.compensationType"
        :style="{ color: row.compensationType === 1 ? '#1890ff' : 'red' }">{{ row.compensationNumStr }}</span><span
        v-else>补差</span></el-button>
  </el-popover>
</template>

<script>
import { matchFractionalPart2 } from '@/utils/regExp'
const formParams = {
  compensationNum: '', // 金额
  compensationType: '' // 1是补 2是扣
}
export default {
  props: {
    row: {
      // 行数据
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      maxNum: 99999,
      rules: {
        compensationType: {
          required: true,
          message: '请选择方式 ',
          trigger: ['blur', 'change']
        },
        compensationNum: [
          {
            required: true,
            message: '请输入金额 ',
            trigger: ['blur', 'change']
          },
          {
            required: true,
            pattern: matchFractionalPart2,
            message: '请输入数字，最多保留两位小数 ',
            trigger: ['blur', 'change']
          },
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value > this.maxNum) {
                callback(new Error(`请输入小于${this.maxNum}的数字`))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      form: Object.assign({}, formParams),
      visible: false // 是否展示
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.form.compensationNum = this.row.compensationNum
        this.form.compensationType = this.row.compensationType
      }
    }
  },
  methods: {
    // 取消
    onCancel() {
      this.$refs.form.resetFields()
      this.visible = false
    },
    // 确定
    onSure() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.$emit('setTable', { id: this.row.id, ...this.form })
          this.$refs.form.resetFields()
          this.visible = false
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/pc/kuaishou/userData/CompensationPop.vue